import { cn } from "@repo/ui/utils"

import { Glow } from "@/components/glow"
import { Signature } from "@/components/signature"

import Image from "next/image"

import { EmailSignup } from "../email-signup"
import styles from "./elias-signoff.module.css"

export function EliasSignoff(props: React.ComponentProps<"div">) {
  return (
    <>
      <div className={styles["container"]} {...props}>
        <div className={styles["glowContainer"]}>
          <Glow />
        </div>
        <div className={styles["content"]}>
          <figure>
            <Image alt="Elias Torres" height="1600" src="/elias-1600.jpg" width="1600" />
          </figure>
          <Signature />
          <span className={styles["signoff"]}>
            <strong>Elias Torres</strong>
            <br />
            Your customer success manager
          </span>
          <EmailSignup className={cn("z-500 mt-10 shadow-lg md:hidden")} />
        </div>
      </div>
      <EmailSignup className={cn("bottom-9 z-500 hidden shadow-lg md:fixed md:block")} />
    </>
  )
}
